import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 relative" data-id="element-208">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-209">
        <FadeIn data-id="element-210">
          <div className="bg-gradient-to-br from-dark-100 to-dark border border-gold-500/20 p-8 md:p-12 rounded-sm text-center relative overflow-hidden" data-id="element-211">
            {/* Subtle glow */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gold-500/5 blur-[80px] pointer-events-none" data-id="element-212"></div>

            <Clock className="w-12 h-12 text-gold-400 mx-auto mb-6 opacity-80" data-id="element-213" />

            <h2 className="text-3xl md:text-4xl font-serif text-white mb-8" data-id="element-214">
              El Cambio en{' '}
              <span className="text-gold-400 italic" data-id="element-215">72 Horas</span>
            </h2>

            <p className="text-xl text-gray-300 leading-relaxed font-light mb-8" data-id="element-216">
              La mayoría de las usuarias reportan que, tras años de persecución,
              al aplicar el primer ciclo de silencio estratégico, reciben el
              primer mensaje de{' '}
              <span className="text-white font-medium" data-id="element-217">"extraño"</span> o{' '}
              <span className="text-white font-medium" data-id="element-218">"¿estás bien?"</span> en
              menos de 3 días.
            </p>

            <p className="text-lg text-gold-400/80 italic font-serif" data-id="element-219">
              No es magia, es cómo funciona el instinto de caza masculino ante
              la pérdida de control.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}